export default {
    label: 'Enter your license plate and choose regular service, recall action, tire change partner or the nearest charging station.',
    description: 'In order to identify your vehicle, it is necessary to enter the registration number of your vehicle.',

    submitButton: 'Continue',
    logoutButton: 'Back to top',

    validationLicensePlate: 'Please enter the registration number of your vehicle.',
    validationRecaptcha: 'Please confirm you are not a robot.',

    infoMessageLogout: 'You have been successfully logged off.',
    successMessageLogin: 'Logging in successful, you may select the service location.',
    errorNoMaintenance: 'You do not have agreed on a maintenance service with us.',
    errorMessageLogin: 'We´re sorry, the request for ordering into a car service may not be submitted for this vehicle. Please check the registration number of your car and try again. If you encounter further difficulties, please contact as at the driver service line +420 296 333 666.'
}
